module.exports = "/assets/fb30816f0f5ef5b4ba7a7401d660a62d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/SJ.png
// module id = 1823
// module chunks = 0